import type { SagraListing } from "@/types/sagra";
import type { NearbyEvent } from "@/types/nearby";

/**
 * Verifica se un valore è un numero finito valido
 */
export function isFiniteCoord(n: unknown): n is number {
  return typeof n === "number" && Number.isFinite(n);
}

/**
 * Converte un evento generico (da nearby-index.json o altro) in NearbyEvent
 * Gestisce vari formati di dati (lat/lng diretti, location.geo, date_from/date_to, titolo/title, etc.)
 * CLIENT-SAFE: non usa funzioni server-only
 */
export function toNearbyEventFromAny(ev: any): NearbyEvent | null {
  const lat = ev?.lat ?? ev?.location?.geo?.lat;
  const lng = ev?.lng ?? ev?.location?.geo?.lng;
  if (!isFiniteCoord(lat) || !isFiniteCoord(lng)) return null;

  const date_from = ev?.date_from ?? ev?.startDate ?? null;
  const date_to = ev?.date_to ?? ev?.endDate ?? null;

  return {
    id: ev.id,
    eid: ev.id,
    slug: ev.slug,
    titolo: ev.titolo ?? ev.title,
    lat,
    lng,
    date_from: date_from ?? undefined,
    date_to: date_to ?? undefined,
    comune: ev.comune,
    provincia: ev.provincia,
    regione: ev.regione,
    year: ev.year ?? ev.currentYear,
    url: ev.targetUrl,
  };
}

